export { default as Device } from './Device'
export { default as NewDevice } from './NewDevice'
export { default as DeviceList } from './DeviceList'
export { default as DeviceDetail } from './DeviceDetail'
